import ClassNames from "classnames"
import React, { useRef, useState } from "react"
import { includes, flatten, get, isEmpty, orderBy } from "lodash"

import { Panel } from "./index"
import { SearchToggle } from "components/molecules/filter/toggleFilter"
import { SearchInput } from "components/atoms/input/input"
import { SearchIcon } from "components/atoms/icon"
import { PAGE_NUM, DETAIL_SEARCH_CONDITIONS, KEY_CODE } from "config/const"
import { DetailSearchProps } from "components/pages/main/tool"
import { includeArray, open_symbol_detail } from "utils/util"
import { BaseTable, InfoTable } from "components/molecules/table"
import { infoTableColumns, tableColumns } from "config/table_columns"
import { Pagination } from "components/molecules/pagination"
import store from "redux/store"
import { showSymbol } from "redux/ducks/SymbolDetail"
import { APIResponse } from "redux/apis/types"
import { MiniChartComponent } from "components/molecules/chart/miniChart"
import { BarChartComponent } from "components/atoms/chart/barChart"
import { pageLoad } from "redux/ducks/PageLoad"
import { SymbolRegisterModal } from "components/organisms/modals/symbolRegisterModal"
import { SearchKeyword } from "components/utils/search"

export const DetailSearch: React.FC<DetailSearchProps> = props => {
  const mainElement = useRef<HTMLDivElement>(null)
  const [sortDirection, changeSortDirection] = useState<string | null>(null)
  const [isShowModal, showModal] = useState(false)
  const data = get(props.data, "ResultList", [])
  const allMarketList = flatten(
    DETAIL_SEARCH_CONDITIONS.MARKETS.map(li => li.markets)
  )
  const allSpIndustryList = flatten(
    DETAIL_SEARCH_CONDITIONS.SP_SECTOR.map(list => list.contents)
  )

  const SearchButton: React.FC = () => (
    <div
      className="btn btn-primary btn-shaped"
      onClick={() =>
        props.searchAction({
          type: "LOAD_DETAIL",
        })
      }
    >
      検索
    </div>
  )
  return (
    <>
      <Panel
        refElm={mainElement}
        title=""
        className="panel-symbol-search"
        // refresh={() => store.dispatch(pageLoad())}
        filter={
          <div className="control-row filter-control-row">
            <div className="filter-control-item">
              <SearchKeyword
                keyword={props.searchState.keyword}
                setKeyword={(str: string) =>
                  props.searchAction({
                    type: "CHANGE_DETAIL_KEYWORD",
                    keyword: str,
                  })
                }
                execute={() =>
                  props.searchAction({
                    type: "LOAD_DETAIL",
                  })
                }
                inputId="search-keyword"
              />
            </div>
            <div className="filter-control-item comparison">
              <div
                className="btn btn-primary btn-shaped"
                onClick={() => {
                  if (isEmpty(props.searchState.compare)) return
                  showModal(true)
                }}
              >
                選択された銘柄を登録
              </div>
              <div
                className="btn btn-primary btn-shaped"
                onClick={() =>
                  props.searchAction({ type: "CHANGE_COMPARE_MODE" })
                }
              >
                選択された銘柄を比較
              </div>
              <div
                className="btn btn-primary btn-shaped"
                onClick={() =>
                  props.searchAction({ type: "RESET_COMPARE_SYMBOL" })
                }
              >
                比較銘柄をクリア
              </div>
            </div>
          </div>
        }
      >
        <div className="search-toggle-wrapper">
          <div className="search-toggle-col">
            <SearchToggle
              title="国・取引所"
              active={includes(props.searchState.openToggle, 0)}
              onToggle={() =>
                props.searchAction({ type: "CHANGE_DETAIL_TOGGLE", id: 0 })
              }
            >
              <div
                className={ClassNames(
                  "panel-filter-list-col search-toggle-market",
                  {
                    "is-open": includes(props.searchState.openToggle, 0),
                  }
                )}
              >
                <div className="control-row filter-control-row">
                  <label className="checkbox-control">
                    <input
                      type="checkbox"
                      checked={
                        props.searchState.markets.length ===
                        allMarketList.length
                      }
                      onChange={() =>
                        props.searchAction({
                          type: "ALL_DETAIL_MARKET",
                          all: allMarketList.map(o => o.id),
                        })
                      }
                    />
                    <span>全て</span>
                  </label>
                </div>
                <ul className="panel-filter-check-list list-checkbox">
                  {DETAIL_SEARCH_CONDITIONS.MARKETS.map((list, i) => (
                    <li
                      key={i}
                      className={ClassNames("", {
                        "is-list": list.markets.length > 1,
                      })}
                    >
                      <div className="panel-filter-check-secondary">
                        <label className="checkbox-control">
                          <input
                            type="checkbox"
                            onChange={() =>
                              props.searchAction({
                                type: "CHANGE_DETAIL_COUNTRY",
                                all: list.markets.map(o => o.id),
                              })
                            }
                            checked={includeArray(
                              props.searchState.markets,
                              list.markets.map(o => o.id)
                            )}
                          />
                          <span>{list.country}</span>
                        </label>
                      </div>
                      {list.markets.length > 1 ? (
                        <ul className="panel-nest-filter-check-list">
                          {list.markets.map((row, j) => (
                            <li key={j}>
                              <label className="checkbox-control">
                                <input
                                  type="checkbox"
                                  onChange={() =>
                                    props.searchAction({
                                      type: "CHANGE_DETAIL_MARKET",
                                      id: row.id,
                                    })
                                  }
                                  checked={includes(
                                    props.searchState.markets,
                                    row.id
                                  )}
                                />
                                <span>{row.name}</span>
                              </label>
                            </li>
                          ))}
                        </ul>
                      ) : null}
                    </li>
                  ))}
                </ul>
                <SearchButton />
              </div>
            </SearchToggle>
            <SearchToggle
              title="東証33業種(日本株のみ)"
              active={includes(props.searchState.openToggle, 1)}
              onToggle={() =>
                props.searchAction({ type: "CHANGE_DETAIL_TOGGLE", id: 1 })
              }
            >
              <div
                className={ClassNames(
                  "panel-filter-list-col search-toggle-JPindustry",
                  {
                    "is-open": includes(props.searchState.openToggle, 1),
                  }
                )}
              >
                <div className="control-row filter-control-row">
                  <label className="checkbox-control">
                    <input
                      type="checkbox"
                      checked={
                        DETAIL_SEARCH_CONDITIONS.TP_SECTORS.length ===
                        props.searchState.jpIndustry.length
                      }
                      onChange={() =>
                        props.searchAction({
                          type: "ALL_DETAIL_JP_INDUSTRY",
                          all: DETAIL_SEARCH_CONDITIONS.TP_SECTORS.map(
                            o => o.id
                          ),
                        })
                      }
                    />
                    <span>全て</span>
                  </label>
                </div>
                <ul className="panel-filter-check-list">
                  {DETAIL_SEARCH_CONDITIONS.TP_SECTORS.map((row, i) => (
                    <li key={i}>
                      <div className="panel-filter-check-secondary">
                        <label className="checkbox-control">
                          <input
                            type="checkbox"
                            onChange={() =>
                              props.searchAction({
                                type: "CHANGE_DETAIL_JP_INDUSTRY",
                                id: row.id,
                              })
                            }
                            checked={includes(
                              props.searchState.jpIndustry,
                              row.id
                            )}
                          />
                          <span>{row.name}</span>
                        </label>
                      </div>
                    </li>
                  ))}
                </ul>
                <SearchButton />
              </div>
            </SearchToggle>
            <SearchToggle
              title="S&P69業種"
              active={includes(props.searchState.openToggle, 2)}
              onToggle={() =>
                props.searchAction({ type: "CHANGE_DETAIL_TOGGLE", id: 2 })
              }
            >
              <div
                className={ClassNames(
                  "panel-filter-list-col search-toggle-SPindustry",
                  {
                    "is-open": includes(props.searchState.openToggle, 2),
                  }
                )}
              >
                <div className="control-row filter-control-row">
                  <label className="checkbox-control">
                    <input
                      type="checkbox"
                      checked={
                        allSpIndustryList.length ===
                        props.searchState.spIndustry.length
                      }
                      onChange={() => {
                        const allId: Array<number> = []
                        DETAIL_SEARCH_CONDITIONS.SP_SECTOR.forEach(o =>
                          o.contents.forEach(row => allId.push(row.id))
                        )
                        props.searchAction({
                          type: "ALL_DETAIL_SP_INDUSTRY",
                          all: allId,
                        })
                      }}
                    />
                    <span>全て</span>
                  </label>
                </div>
                <ul className="panel-filter-check-list list-checkbox">
                  {DETAIL_SEARCH_CONDITIONS.SP_SECTOR.map((list, i) => (
                    <li key={i} className="is-list">
                      <div className="panel-filter-check-secondary">
                        <label className="checkbox-control">
                          <input
                            type="checkbox"
                            onChange={() =>
                              props.searchAction({
                                type: "CHANGE_DETAIL_SP_CATEGORY",
                                all: list.contents.map(row => row.id),
                              })
                            }
                            checked={includeArray(
                              props.searchState.spIndustry,
                              list.contents.map(row => row.id)
                            )}
                          />
                          <span>{list.category}</span>
                        </label>
                      </div>
                      <ul className="panel-nest-filter-check-list">
                        {list.contents.map((row, j) => (
                          <li key={j}>
                            <label className="checkbox-control">
                              <input
                                type="checkbox"
                                onChange={() =>
                                  props.searchAction({
                                    type: "CHANGE_DETAIL_SP_INDUSTRY",
                                    id: row.id,
                                  })
                                }
                                checked={includes(
                                  props.searchState.spIndustry,
                                  row.id
                                )}
                              />
                              <span>{row.name}</span>
                            </label>
                          </li>
                        ))}
                      </ul>
                    </li>
                  ))}
                </ul>
                <SearchButton />
              </div>
            </SearchToggle>
          </div>
          <div className="result-col">
            <BaseTable
              className="table-list-view table-striped"
              list={tableColumns.tool.detail((data: APIResponse.Res) => {
                props.searchAction({ type: "ADD_COMPARE_SYMBOL", symbol: data })
              }, props.searchState)}
              data={data}
              onClick={(data: object, index: number, row: object) => {
                if (get(row, "id") === 0) {
                  props.searchAction({
                    type: "ADD_COMPARE_SYMBOL",
                    symbol: data,
                  })
                } else {
                  open_symbol_detail(data)
                }
              }}
              sortTarget={{ target: "", type: sortDirection }}
              onSort={(row: object) => {
                if (isEmpty(props.data)) return
                if (!sortDirection) {
                  changeSortDirection("desc")
                  props.searchAction({
                    type: "SORT_SYMBOL_DETAIL",
                    sort: `${get(row, "sortable")} desc`,
                  })
                } else if (sortDirection === "desc") {
                  changeSortDirection("asc")
                  props.searchAction({
                    type: "SORT_SYMBOL_DETAIL",
                    sort: `${get(row, "sortable")} asc`,
                  })
                } else if (sortDirection === "asc") {
                  changeSortDirection(null)
                  props.searchAction({
                    type: "SORT_SYMBOL_DETAIL",
                    sort: null,
                  })
                }
              }}
            />
            <Pagination
              list={data}
              current={props.searchState.page}
              page={PAGE_NUM.PAGE_20}
              total={get(props.data, "TotalCount", null)}
              changePage={(p: number) => {
                props.searchAction({ type: "CHANGE_DETAIL_PAGE", page: p })
              }}
              scrollUpElement={mainElement.current}
            />
          </div>
        </div>
      </Panel>
      <SymbolRegisterModal
        isShow={isShowModal}
        onHide={showModal}
        registerSymbol={props.registerSymbol}
        selectData={props.searchState.compare}
      />
    </>
  )
}

const TestBarChart = () => (
  <BarChartComponent
    data={[
      { name: "test1", volume: 700 },
      { name: "test2", volume: 100 },
      { name: "test3", volume: 500 },
      { name: "test4", volume: 200 },
      { name: "test5", volume: 900 },
    ]}
    option={{ height: 200 }}
  />
)
export const DetailCompare: React.FC<DetailSearchProps> = props => {
  const mainElement = useRef<HTMLDivElement>(null)
  const componentList = [
    {
      title: "詳細",
      component: (data: APIResponse.Res) => {
        return (
          <div className="comparsion-items comparsion-chart-list">
            <MiniChartComponent
              data={get(data, ["GetCompanyInfo", "Symbol"], {})}
              labelVisible={true}
            />
            <InfoTable
              list={infoTableColumns.compareSymbol}
              data={get(data, ["GetCompanyInfo", "Symbol"], {})}
              className="table-striped table-index-detail"
              wrapperCls="index-detail-table-row"
            />
          </div>
        )
      },
    },
    {
      title: "東証33業種",
      component: (data: APIResponse.Res) => {
        return (
          <div className="comparsion-items">
            {get(data, ["GetCompanyInfo", "Symbol", "JSecCodeName"])}
          </div>
        )
      },
    },
    {
      title: "S&P69業種",
      component: (data: APIResponse.Res) => {
        return (
          <div className="comparsion-items">
            {get(data, ["GetCompanyInfo", "Symbol", "SPSecCodeName"])}
          </div>
        )
      },
    },
    {
      title: "企業概要",
      component: (data: APIResponse.Res) => {
        return (
          <div className="comparsion-items">
            {get(data, ["GetCompanyInfo", "CompanyInfo", "Description"])}
          </div>
        )
      },
    },
    {
      title: "売上高",
      component: (data: APIResponse.Res) => {
        return (
          <div className="comparsion-items">
            <BarChartComponent
              data={orderBy(get(data, ["Uriagedaka"]), ["Nendo"], ["asc"])}
            />
          </div>
        )
      },
    },
    {
      title: "純利益",
      component: (data: APIResponse.Res) => {
        return (
          <div className="comparsion-items">
            <BarChartComponent
              data={orderBy(get(data, ["ToukiRieki"]), ["Nendo"], ["asc"])}
            />
          </div>
        )
      },
    },
    {
      title: "1株純資産",
      component: (data: APIResponse.Res) => {
        return (
          <div className="comparsion-items">
            <BarChartComponent
              data={orderBy(get(data, ["BPS"]), ["Nendo"], ["asc"])}
            />
          </div>
        )
      },
    },
    {
      title: "配当",
      component: (data: APIResponse.Res) => {
        return (
          <div className="comparsion-items">
            <BarChartComponent
              data={orderBy(get(data, ["DPS"]), ["Nendo"], ["asc"])}
            />
          </div>
        )
      },
    },
  ]
  return (
    <Panel
      refElm={mainElement}
      title=""
      className="panel-symbol-compare"
      nonePanelHeader={true}
    >
      <div className="control-row filter-control-row ">
        <div className="filter-control-item right-justify">
          <div
            className="btn btn-primary btn-shaped"
            onClick={() => props.searchAction({ type: "CHANGE_COMPARE_MODE" })}
          >
            検索条件設定に戻る
          </div>
        </div>
      </div>
      <div className="search-toggle-wrapper">
        <div className="result-col">
          <table className="table-striped">
            <tbody>
              {componentList.map((list, i: number) => (
                <div
                  key={i}
                  className={`comparsion-contents row-${props.searchCompareData.length}`}
                >
                  <tr className="comparsion-items-title title-border">
                    <th>{list.title}</th>
                  </tr>
                  <tr>
                    {props.searchCompareData.map((data, j) => {
                      return (
                        <td
                          className={`row-${props.searchCompareData.length}`}
                          key={j}
                        >
                          {list.component(data)}
                        </td>
                      )
                    })}
                  </tr>
                </div>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </Panel>
  )
}
